import { Box } from '@mui/material'
import SpendingLimits from '../SpendingLimits'

const SecurityLogin = () => {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <SpendingLimits />
    </Box>
  )
}

export default SecurityLogin
